export const useScrollTo = () => {
  const getElementPosition = (element) => {
    // return element?.offsetTop || 0;
    return element?.getBoundingClientRect().top + window.scrollY || 0;
  };

  const scrollTo = (target, offset = 0) => {
    const elementPosition = getElementPosition(target);

    window.scrollTo({top: elementPosition - offset, behavior: 'smooth'});
  };

  return {
    scrollTo
  };
};
